import styled from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Content = styled.div`
    display: flex;
    flex-direction: column;
`

export const Benefits = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: end;
    align-self: center;

    > * + * {
        margin-left: 10px;
    }

    ${mobile(`
       max-width: 220px;

       div {
        flex-grow: 1;
       } 

       img {
          width: 100%;
       }
    `)}
`

export const List = styled.div`
    max-width: 1140px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin-bottom: 50px;
    margin: 0 15px;

    & > div {
        flex: 1 1 calc(32% - 25px);
        max-width: calc(33% - 25px);
    }

    ${mobile(`
        padding-top: 20px;
        padding-bottom: 20px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: auto;
        row-gap: 40px;

        & > div {
            max-width: 100%;
        }

        & > div .Accordion__desc {
            border-bottom: 2px solid #d7d7d7;
        }
    `)}
`

export const Item = styled.div`
    text-align: left;
    flex: 30%;
    display: flex;
    flex-direction: column;
    margin: 30px 20px 0 0;
    overflow-wrap: break-word;

    > * + * {
        margin-top: 30px;
    }

    ${mobile(`
        margin: 0;
        flex: 0;
        flex-basis: 50%;
    `)}
`

export const ItemTitle = styled.h3`
    position: relative;
    font-size: 24px;
    font-weight: 800;
    line-height: 30.48px;
    color: ${({ $color }) => $color || colors.darkGreen};

    &:before {
        content: '';
        position: absolute;
        height: 5px;
        width: 23%;
        background-color: ${({ $bgColor }) => $bgColor || colors.darkGreen};
        border-radius: 4px;
        bottom: -15px;
    }
`

export const ItemDesc = styled.span`
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;

    color: ${colors.black};

    ${mobile(`
        display: none;
    `)}
`
